/* eslint-disable camelcase */

export const images = [
    '/assets/placeholder/1.jpg',
    '/assets/placeholder/2.jpg',
    '/assets/placeholder/3.jpg',
    '/assets/placeholder/4.jpg',
    '/assets/placeholder/5.jpg',
    '/assets/placeholder/6.jpg',
    '/assets/placeholder/7.jpg',
    '/assets/placeholder/8.jpg',
    '/assets/placeholder/9.jpg',
];

export const landscapeImages = [
    '/assets/placeholder/2.jpg',
    '/assets/placeholder/4.jpg',
    '/assets/placeholder/5.jpg',
    '/assets/placeholder/7.jpg',
    '/assets/placeholder/9.jpg',
];

export const videos = [
    'https://vimeo.com/257717109',
    'https://vimeo.com/249968820',
    'https://vimeo.com/946821430'
];

export const quotes = [
    '<p data-textsize="lg" class="lg">Life is a series of natural and spontaneous changes. Don’t resist them; that only creates sorrow. Let reality be reality. Let things flow naturally forward in whatever way they like. – Lao Tzu</p>',
    '<p data-textsize="lg" class="lg">The best ideas are usually those that come without effort, out of the blue. The great intellectual creations come easily. Only a great person can create something great, and such a one works without strain. — John Ruskin</p>',
    '<p data-textsize="lg" class="lg">The follies of others are obvious, but our own hide from us; we love to parse others’ missteps but we cover up our own, as the cheat conceals the false die. It is in the nature of men to lay blame: we see others’ mistakes while our own passions swell, carrying us ever farther from improvement. — Buddhist wisdom</p>',
    '<p data-textsize="lg" class="lg">When we are clear about things, we have knowledge; with knowledge, we seek the path of truth; when the search is rewarded, the heart becomes good; with the heart made good, the moral view of things that leads to virtue is attained. — Confucius</p>',
];
